import { yupResolver } from "@hookform/resolvers/yup";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { Button, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ControlledTextFieldSeparatedLabel from "../../../../components/controlled/ControlledTextFieldSeparatedLabel/index.jsx";
import { useUpdateComarrIntegrationMutation } from "../../integrationsApiSlice.js";
import { getFormSchema } from "./formSchema.js";

export const ComarrForm = ({ status, comarrLogin, comarrPassword }) => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();
	const [updateComarrIntegration, { isLoading }] =
		useUpdateComarrIntegrationMutation();

	const formSchema = getFormSchema(t);
	const {
		handleSubmit,
		control,
		formState: { errors },
		setValue,
		setError,
	} = useForm({
		defaultValues: {
			comarrLogin,
			comarrPassword,
		},
		resolver: yupResolver(formSchema),
		shouldFocusError: true,
	});

	useEffect(() => {
		if (comarrLogin) {
			setTimeout(() => {
				setValue("comarrLogin", comarrLogin);
			}, 200);
		}
		if (comarrPassword) {
			setTimeout(() => {
				setValue("comarrPassword", comarrPassword);
			}, 200);
		}
	}, [comarrLogin, comarrPassword, setValue]);

	useEffect(() => {
		if (Object.keys(errors).length > 0) {
			Object.values(errors).forEach((err) => {
				if (err.message) {
					enqueueSnackbar(err.message, {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
		}
	}, [errors, enqueueSnackbar]);

	const onSubmit = async ({ comarrLogin, comarrPassword }) => {
		await updateComarrIntegration({
			comarrLogin,
			comarrPassword,
		})
			.unwrap()
			.then((_payload) => {
				enqueueSnackbar(t("updated_comarr_integration"), {
					variant: "success",
				});
			})
			.catch((error) => {
				if (error?.data?.errors) {
					const errors = error.data.errors;
					Object.entries(errors).forEach(([key, message]) => {
						setError(key);
						enqueueSnackbar(message[0], {
							variant: "error",
							preventDuplicate: true,
						});
					});
				} else {
					enqueueSnackbar(error?.data?.message || t("default_error"), {
						variant: "error",
						preventDuplicate: true,
					});
				}
			});
	};

	return (
		<Box
			component="form"
			autoComplete="off"
			noValidate
			onSubmit={handleSubmit(onSubmit)}
			sx={{ p: 0 }}
		>
			<Box
				sx={{
					mb: 1,
					display: "flex",
					alignItems: "center",
					gap: "6px",
				}}
			>
				<Typography sx={{ fontWeight: 600 }}>{t("status")}: </Typography>
				{status ? (
					<Chip label={t("integrated")} color="success" />
				) : (
					<Chip label={t("no_integration")} color="secondary" />
				)}
			</Box>
			<input type="text" style={{ display: "none" }} />
			<input type="password" style={{ display: "none" }} />
			<Grid container spacing={5}>
				<Grid size={6}>
					<Grid container spacing={2}>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="comarrLogin"
								type="text"
								label="Comarr Login"
								error={!!errors?.comarrLogin}
								labelXs={6}
								fieldXs={6}
								autoComplete="off comarrLogin new-password"
								inputProps={{
									autoComplete: "off comarrLogin new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<ControlledTextFieldSeparatedLabel
								control={control}
								name="comarrPassword"
								type="password"
								label="Comarr Password"
								error={!!errors?.comarrPassword}
								labelXs={6}
								fieldXs={6}
								autoComplete="off comarrPassword new-password"
								inputProps={{
									autoComplete: "off comarrPassword new-password",
								}}
							/>
						</Grid>
						<Grid size={12}>
							<Box sx={{ display: "flex", justifyContent: "end" }}>
								<Button loading={isLoading} type="submit" variant="contained">
									{t("save")}
								</Button>
							</Box>
						</Grid>
					</Grid>
				</Grid>
				<Grid size={6}>
					{/* <Box
						sx={{
							border: "2px solid #ffc000",
							background: "#ffffd9",
							padding: "14px",
							maxWidth: "500px",
						}}
					>
						<Typography>
							{t("tele_integration_info_1")}
							<br />
							{t("tele_integration_info_2")}
						</Typography>
					</Box> */}
				</Grid>
			</Grid>
		</Box>
	);
};
